<template>
  <div class=''>
      <div class="header">
          <!-- 左侧 -->
          <div class="left_box">
              <div class="img_box" @click="gotoHome">
                  <img src="../../assets/img/headerlogo.png" alt="">
              </div>
          </div>
          <!-- 右侧 -->
          <div class="right_box">
              <div class="img_box">
                  <img src="../../assets/img/shangchuan.png" alt="">
              </div>
              <div class="img_box margin">
                  <img src="../../assets/img/duoyuyan.png" alt="">
              </div>
              <div class="menu_box margin">
                    <div class="img_box right">
                        <img src="../../assets/img/weidenglu.png" alt="">
                    </div>
                    <el-dropdown @command="clickMenu">
                        <span class="el-dropdown-link">
                            {{login.username}}<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown" :append-to-body="false" ref="dropdown">
                            <el-dropdown-item command="security" v-if="login.security.all">Account Management</el-dropdown-item>
                            <el-dropdown-item command="Approval" v-if="login.security.all">Approval Process Management</el-dropdown-item>
                            <el-dropdown-item command="account">{{$t('header.account')}}</el-dropdown-item>
                            <el-dropdown-item command="logout">{{$t('header.logout')}}</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <div ref="newspase"></div>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》'

export default {
  name: 'index',
  // import引入的组件需要注入到对象中才能使用
  components: {},
  props: {
    
    windowWidth:{
      type: Number,
    }
  },
  data () {
    // 这里存放数据
    return {
        login:{},
        host:null,
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {
    windowWidth:function(val){
      this.windowWidth = val
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
    this.login = JSON.parse(sessionStorage.getItem('login'))
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
        this.host = window.location.hostname
        this.$refs.newspase.appendChild(
            this.$refs.dropdown.popperElm
        )
      
        var that = this;
        window.onresize = () => {
        return (() => {
            window.fullHeight = document.documentElement.clientHeight;
            window.fullWidth = document.documentElement.clientWidth;
            that.windowHeight = window.fullHeight;  // 高
            that.windowWidth = window.fullWidth; // 宽
        })()
        };
  },
  beforeCreate () {}, // 生命周期 - 创建之前
  beforeMount () {}, // 生命周期 - 挂载之前
  beforeUpdate () {}, // 生命周期 - 更新之前
  updated () {}, // 生命周期 - 更新之后
  beforeDestroy () {}, // 生命周期 - 销毁之前
  destroyed () {}, // 生命周期 - 销毁完成
  activated () {}, // 如果页面有keep-alive缓存功能，这个函数会触发
  // 方法集合
  methods: {
        clickMenu(comend){
            console.log(comend)
            if(comend == 'Approval'){
                this.$router.push('/approval')
            }else if(comend == 'security'){
                this.$router.push('/security')
            }else if(comend == 'logout'){
                sessionStorage.clear()
                this.$router.push('/')
            }else if(comend == 'account'){
                let id = JSON.parse(sessionStorage.getItem('login')).id
                this.$router.push({
                    path:'/accountDetail',
                    query:{
                        id:id
                    }
                })
            }
        },
        gotoHome(){
            this.$router.push('/carbon')
        }
        
  }
}
</script>

<style lang='scss' scoped>
//@import url(); 引入公共css类
.header{
    height: 68px;
    background: linear-gradient(95deg, #1E9273 0%, #029570 100%);
    box-shadow: 0px 4px 14px 0px rgba(0,58,42,0.58);
    // transform: translate3d(0, 0, 0);
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 40px;
    .left_box{
        .img_box{
            width: 214px;
            cursor: pointer;
            img{
                width: 100%;
                height: 100%;
            }
            
        }
    }
    .right_box{
        display: flex;
        align-items: center;
        .img_box{
            width: 26px;
            height: 26px;
            img{
                width: 100%;
                height: 100%;
            }
        }
        .margin{
            margin-left: 39px;
        }
        .right{
            margin-right: 7px;
        }
        .menu_box{
            display: flex;
            align-items: center;
            
        }
    }
}
::v-deep .el-dropdown-link{
    font-size: 18px;
    font-family: Arial-BoldMT, Arial;
    font-weight: normal;
    color: #FFFFFF;
    line-height: 21px;
}
::v-deep .el-dropdown-menu{
    // padding: 10px 30px;
    font-size: 20px;
    font-family: ArialMT;
    color: #626262;
    line-height: 26px;
}

::v-deep .el-dropdown-menu__item{
    padding: 5px 50px;
    font-size: 16px;
}
::v-deep .el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover{
    color: #158169;
}

// ::v-deep .el-popper[x-placement^=bottom]{
//     margin-top: 20px;
// }
</style>
